module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_006.png
// module id = 2353
// module chunks = 5